import { catchError, Observable, throwError } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { TurnstileService } from '../services/turnstile.service';

@Injectable()
export class TurnstileHeaderInterceptor implements HttpInterceptor {
  turnstileService = inject(TurnstileService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has('X-Skip-Turnstile')) {
      const cleanRequest = request.clone({
        headers: request.headers.delete('X-Skip-Turnstile')
      });
      return next.handle(cleanRequest);
    }

    const turnstileRequest = request.clone({
      setHeaders: {
        'X-CF-Turnstile': this.turnstileService.getCustomHeader()
      }
    });

    return next.handle(turnstileRequest).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status == 401 && err.headers.get('X-CF-Turnstile-validation')?.length) {
          this.turnstileService.onReset();
        }

        throw err;
      })
    );
  }
}